import { Injectable } from "@angular/core";
import "rxjs/add/operator/map";
import { TranslateService } from "@ngx-translate/core";
import { LocalNotifications } from "@ionic-native/local-notifications";
import * as moment from "moment";
import {sprintf} from "sprintf-js";

@Injectable()
export class NotificationService {
  private fillValue:any = null;
  constructor(
    private translate: TranslateService,
    private localNotifications: LocalNotifications
  ) {}

  public setFillValue(value)
  {
    this.fillValue = value;
  }

  public sendNotification(message: string) {
    this.translate.get(message).subscribe(translation => {
      if(this.fillValue)
      {
        translation = sprintf(translation, this.fillValue);
      }
      this.localNotifications.schedule({
        id: moment().unix(),
        text: translation,
        sound: null,
        icon: 'res://icon',
        smallIcon: 'res://warning'
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/api/notification.service.ts